
(() => {
  let timer = null;
  let gridActive = null;
  let pausedUntil = 0;

  function init() {
    const grid = document.querySelector('.jdgm-grid-body');
    if (!grid) return;

    // Deschide automat toate recenziile
    const button = document.querySelector(
      '.jm-show-more-button, .jdgm-show-more-button'
    );

    (() => {
  let timer = null;
  let gridActive = null;
  let pausedUntil = 0;

  function init() {
    const grid = document.querySelector('.jdgm-grid-body');
    if (!grid) return;

    // Deschide automat toate recenziile
    const button = document.querySelector(
      '.jm-show-more-button, .jdgm-show-more-button'
    );

    
if (button && !button.disabled) {
  button.click();
}


    // Porneste derularea o singura data pe grila
    if (gridActive === grid) return;

    gridActive = grid;

    if (timer) clearInterval(timer);

    const pause = () => {
      pausedUntil = Date.now() + 4000;
    };

    grid.addEventListener('touchstart', pause, { passive: true });
    grid.addEventListener('pointerdown', pause);
    grid.addEventListener('wheel', pause, { passive: true });

    timer = setInterval(() => {
      if (document.hidden || Date.now() < pausedUntil) return;

      const max = grid.scrollWidth - grid.clientWidth;
      if (max <= 0) return;

      if (grid.scrollLeft >= max - 2) {
        grid.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        grid.scrollLeft += 1;
      }
    }, 40);
  }

  // Asteapta incarcarea recenziilor Judge.me
  const observer = new MutationObserver(init);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('DOMContentLoaded', init);
  init();
})();


    // Porneste derularea o singura data pe grila
    if (gridActive === grid) return;

    gridActive = grid;

    if (timer) clearInterval(timer);

    const pause = () => {
      pausedUntil = Date.now() + 4000;
    };

    grid.addEventListener('touchstart', pause, { passive: true });
    grid.addEventListener('pointerdown', pause);
    grid.addEventListener('wheel', pause, { passive: true });

    timer = setInterval(() => {
      if (document.hidden || Date.now() < pausedUntil) return;

      const max = grid.scrollWidth - grid.clientWidth;
      if (max <= 0) return;

      if (grid.scrollLeft >= max - 2) {
        grid.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        grid.scrollLeft += 1;
      }
    }, 40);
  }

  // Asteapta incarcarea recenziilor Judge.me
  const observer = new MutationObserver(init);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('DOMContentLoaded', init);
  init();
})();
